import React from 'react';
import PropTypes from 'prop-types';
import ExternalAccount from '../../../common/externalAccount';
import { getGamblingCompliance } from '../../../common/gamblingCompliance';

export const ExternalTopUpPage = ({
    feed,
    containsTermsInTopUpIframe,
    accountType,
    externalAccountUrl,
    isExternalAccountError,
    onExternalBackButtonClick,
}) => {
    const gamblingCompliance = getGamblingCompliance(feed);
    return (
        <div className="bs-horizontalSlider__element bs-drawer__iframeContainer">
            <div className="bs-drawer__content">
                <ExternalAccount
                    type={accountType}
                    externalAccountUrl={externalAccountUrl}
                    isExternalAccountError={isExternalAccountError}
                    onExternalBackButtonClick={onExternalBackButtonClick}
                />
                {
                    !containsTermsInTopUpIframe ? gamblingCompliance : null
                }
            </div>
        </div>
    )
}

ExternalTopUpPage.propTypes = {
    feed: PropTypes.string.isRequired,
    containsTermsInTopUpIframe: PropTypes.bool.isRequired,
    accountType: PropTypes.string.isRequired,
    externalAccountUrl: PropTypes.string.isRequired,
    isExternalAccountError: PropTypes.bool.isRequired,
    onExternalBackButtonClick: PropTypes.func.isRequired,
};

export default ExternalTopUpPage;



// WEBPACK FOOTER //
// /src/js/drawer/components/TopUpPage/ExternalTopUpPage.jsx